<div class="container">
  <div class="col-md-12">
    <!-- Forgot password -->
    @if (showVerifyForm === "forgotPassword") {
      <div class="card lgFrmCard login-verify-card">
        <form
          [formGroup]="forgotPasswordForm"
          class="loginFormClass"
          autocomplete="off"
        >
          <p class="text-center verify-heading"><b>Forgot your password?</b></p>
          <p class="">
            Resetting your password is easy, just enter the email address you
            registered with CanString AI.
          </p>
          <div class="form-group">
            <label for="" class="form-label mandatoryLabel"
              >Email <i class="fa-solid fa-asterisk mandatoryIcon"></i
            ></label>
            <div class="input-field">
              <input
                id="otp"
                name="otp"
                formControlName="email"
                id="email"
                name="email"
                class="form-control"
                type="email"
                placeholder="Enter your registered email"
                autocomplete="off"
              />
            </div>
            @if (
              forgotPasswordForm.controls["email"].invalid &&
              forgotPasswordForm.controls["email"].dirty &&
              forgotPasswordForm.hasError("required", "email") &&
              forgotPasswordForm.hasError("pattern", "email")
            ) {
              <span class="text-danger"> please enter valid email. </span>
            }
          </div>
          <button
            class="btn btn-primary signInBtn"
            type="submit"
            [disabled]="forgotPasswordForm.invalid || spinner"
            (click)="forgotPasswordFun()"
            (keydown.enter)="forgotPasswordFun()"
          >
            @if (spinner) {
              <i class="fa fa-spinner fa-pulse fa-3x fa-fw fa-spinner-login">
                <span class="sr-only">Loading...</span>
              </i>
            }
            Submit
          </button>
          <p class="ReturnLoginTxt text-center">
            <a class="returnClass" (click)="goBack()" (keydown.enter)="goBack()"
              >Back to Log in</a
            >
          </p>
        </form>
      </div>
    }
    <!-- verify section -->
    @if (showVerifyForm === "verify") {
      <div class="card lgFrmCard login-verify-card">
        <p class="text-center verify-heading">
          @if (!getEmailVerifyResponseData?.is2faenabled) {
            <b>Please confirm your email</b>
          }
          @if (getEmailVerifyResponseData?.is2faenabled) {
            <b>Please confirm Two Factor Authentication</b>
          }
        </p>
        <p class="text-center">We've sent a OTP to your email and mobile</p>
        <form [formGroup]="otpForm">
          <div class="form-group">
            <label for="" class="form-label mandatoryLabel"
              >OTP <i class="fa-solid fa-asterisk mandatoryIcon"></i
            ></label>
            <div class="input-field">
              <input
                id="otp"
                name="otp"
                formControlName="userOTP"
                class="form-control"
                type="text"
                placeholder="Enter your PIN"
              />
            </div>
            @if (otpFormSubmit && otpForm.controls["userOTP"].invalid) {
              <div class="text-danger">Enter valid PIN</div>
            }
          </div>
          <button
            class="btn btn-primary signInBtn"
            type="submit"
            [disabled]="otpForm.invalid || spinner"
            (click)="submitOtp()"
            (keydown.enter)="submitOtp()"
          >
            @if (spinner) {
              <i class="fa fa-spinner fa-pulse fa-3x fa-fw fa-spinner-login">
                <span class="sr-only">Loading...</span>
              </i>
            }
            Verify
          </button>
        </form>
        <p class="ReturnLoginTxt text-center">
          <a class="returnClass" (click)="goBack()" (keydown.enter)="goBack()"
            >Return to Log in</a
          >
        </p>
      </div>
    }

    <!-- otp form section -->
    @if (showVerifyForm === "otp") {
      <div class="card lgFrmCard login-verify-card">
        <form [formGroup]="passwordForm">
          <p class="text-center verify-heading"><b>Reset Password</b></p>
          <div class="form-group">
            <label
              for=""
              class="form-label mandatoryLabel"
              [ngClass]="{ 'is-invalid': submitted && f['password'].errors }"
              >New Password<i class="fa-solid fa-asterisk mandatoryIcon"></i
            ></label>
            <div class="input-field">
              <input
                class="form-control"
                [type]="type"
                formControlName="password"
                id="password"
                name="password"
              />
              <span
                class="fa {{ eyeIcon }} passwordEye"
                (click)="hideShowPassword()"
                (keydown.enter)="hideShowPassword()"
                (keydown.space)="hideShowPassword()"
              ></span>
            </div>
            @if (submitted && f["password"].errors) {
              <div class="invalid-feedback text-danger">
                @if (f["password"].errors["required"]) {
                  <div class="text-danger">New password is required</div>
                }
                @if (f["password"].errors["pattern"]) {
                  <div class="text-danger">
                    Password must be at least 8 characters, and include at least
                    1 number and 1 special character(eg. _, &#64;, or $).
                  </div>
                }
              </div>
            }
          </div>
          <div class="form-group">
            <label for="" class="form-label mandatoryLabel"
              >Confirm Password<i class="fa-solid fa-asterisk mandatoryIcon"></i
            ></label>
            <input
              type="password"
              formControlName="confirmPassword"
              class="form-control"
              [ngClass]="{
                'is-invalid': submitted && f['confirmPassword'].errors,
              }"
            />
            @if (submitted && f["confirmPassword"].errors) {
              <div class="invalid-feedback text-danger">
                @if (f["confirmPassword"].errors["required"]) {
                  <div class="text-danger">Confirm password is required</div>
                }
                @if (f["confirmPassword"].errors["matching"]) {
                  <div class="text-danger">
                    Passwords do not match. Please re-enter your password.
                  </div>
                }
              </div>
            }
          </div>
          <button
            class="btn btn-primary signInBtn"
            type="submit"
            [disabled]="spinner"
            (click)="resetPassword()"
            (keydown.enter)="resetPassword()"
          >
            @if (spinner) {
              <i class="fa fa-spinner fa-pulse fa-3x fa-fw fa-spinner-login">
                <span class="sr-only">Loading...</span>
              </i>
            }
            Reset Password
          </button>
          <p class="ReturnLoginTxt text-center">
            <a class="returnClass" (click)="goBack()" (keydown.enter)="goBack()"
              >Back to Log in</a
            >
          </p>
        </form>
      </div>
    }

    <!-- password updated success fully -->
    @if (showVerifyForm === "passwordSuccess") {
      <div class="card lgFrmCard login-verify-card">
        <p class="text-center verify-heading">
          <b>Password Updated SuccessFully</b>
        </p>
        <div class="col-md-4 offset-md-4">
          <button
            class="btn btn-primary signInBtn passwordSuccessBtn"
            type="submit"
            (click)="goBack()"
            (keydown.enter)="goBack()"
          >
            Return to Login
          </button>
        </div>
      </div>
    }
  </div>
</div>
